import { HelpOutline } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";
import { Fragment } from "react";

export default function StyledHeader({ children, icon, helperText }) {
  return (
    <Box
      sx={{
        borderRadius: "2px",
        overflow: "hidden",
        marginTop: 2,
        marginRight: 2,
      }}
    >
      <Box
        sx={{
          borderLeft: "6px solid",
          borderColor: "secondary.main",
          bgcolor: "primary.main",
          color: "primary.contrastText",
          padding: 1,
          paddingLeft: 2,
        }}
      >
        <Typography variant="h5" display="flex" alignItems="center">
          {icon && (<Fragment>{icon}<Box mr={1} /></Fragment>)}
          {children}
          {
            helperText && (
              <Fragment>
                <Box flex={1} />
                <Tooltip title={helperText}>
                  <HelpOutline />
                </Tooltip>
              </Fragment>
            )
          }
        </Typography>
      </Box>
    </Box>
  );
}
